<template>
    <sa-page-layout :showModalLoading="showModalLoading">
        <template #table-filter>
            <sa-filter-component @submit="onSubmit" @reset="resetFiltroRiepilogoVociMenu" padding-bottom="20px">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Nome Operatore</label>
                        <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                            <input class="sa-page-search-component-input" v-model="filtroRiepilogoVociMenu.firsnameUpdater" />
                        </div>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Cognome Operatore</label>
                        <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                            <input class="sa-page-search-component-input" v-model="filtroRiepilogoVociMenu.lastnameUpdater" />
                        </div>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Cognome paziente</label>
                        <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                            <input class="sa-page-search-component-input" v-model="filtroRiepilogoVociMenu.cognomePaziente" />
                        </div>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Nome paziente</label>
                        <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                            <input class="sa-page-search-component-input" v-model="filtroRiepilogoVociMenu.nomePaziente" />
                        </div>
                    </b-col>
                    <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">
                            {{ filtroRiepilogoVociMenu.useDataEsecuzione ? "Data esecuzione dal..." : "Data creazione dal..." }}
                        </label>
                        <div class="sa-page-search-component-wrapper">
                            <date-picker class="sa-date-like-input" input-class="sa-page-search-component-input" format="DD-MM-YYYY" value-type="timestamp" v-model="filtroRiepilogoVociMenu.dataDal" type="date" />
                        </div>
                    </b-col>
                    <b-col cols="12" sm="12" md="5" lg="5" xl="5">
                        <label class="sa-label-data">
                            {{ filtroRiepilogoVociMenu.useDataEsecuzione ? "Data esecuzione al..." : "Data creazione al..." }}
                        </label>
                        <div class="sa-page-search-component-wrapper">
                            <date-picker class="sa-date-like-input" input-class="sa-page-search-component-input" format="DD-MM-YYYY" value-type="timestamp" v-model="filtroRiepilogoVociMenu.dataAl" type="date" />
                        </div>
                    </b-col>
                    <b-col cols="12" sm="12" md="1" lg="1" xl="1">
                        <!-- <label class="sa-label-data">Tipo Data</label>-->
                        <div style="margin-top: 20px">
                            <b-form-checkbox v-model="filtroRiepilogoVociMenu.useDataEsecuzione" switch size="l">
                                {{ filtroRiepilogoVociMenu.useDataEsecuzione ? "Data Esecuzione" : "Data Creazione" }}
                            </b-form-checkbox>
                        </div>
                    </b-col>
                </b-row>
            </sa-filter-component>
        </template>
        <template #table-body>
            <rsa-riepilogo-voci-diario-list-component ref="riepilogoVociDiarioList" @beforeLoadData="beforeLoadData" @afterLoadData="afterLoadData" />
        </template>
    </sa-page-layout>
</template>
<script>
import SaFilterComponent from "../../../../template/layout/components/SaFilterComponent.vue";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaRiepilogoVociDiarioListComponent from "../components/RsaRiepilogoVociDiarioListComponent.vue";
import DatePicker from "vue2-datepicker";

export default {
    name: "RsaRiepilogoVociDiarioListPage",
    components: { SaFilterComponent, SaPageLayout, RsaRiepilogoVociDiarioListComponent, DatePicker },
    data() {
        return {
            showModalLoading: false,
            filtroRiepilogoVociMenu: {
                lastnameUpdater: "",
                firsnameUpdater: "",
                cognomePaziente: "",
                nomePaziente: "",
                useDataEsecuzione: true,
                dataDal: null,
                dataAl: null,
            },
        };
    },

    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        if (sessionStorage.getItem("filtroRiepilogoVociMenu") != null) {
            me.filtroRiepilogoVociMenu = JSON.parse(sessionStorage.getItem("filtroRiepilogoVociMenu"));
        }
        me.$refs.riepilogoVociDiarioList.loadData(me.filtroRiepilogoVociMenu);
    },

    watch: {
        "filtroRiepilogoVociMenu.useDataEsecuzione"() {
            this.filtroRiepilogoVociMenu.dataDal = null;
            this.filtroRiepilogoVociMenu.dataAl = null;
        },
    },
    methods: {
        onSubmit() {
            let me = this;

            let filtro = { ...me.filtroRiepilogoVociMenu };

            if (filtro.useDataEsecuzione) {
                filtro.dataOraEsecuzioneDal = filtro.dataDal;
                filtro.dataOraEsecuzioneAl = filtro.dataAl;

                filtro.dataOraInizio = null;
                filtro.dataOraFine = null;
            } else {
                filtro.dataOraInizio = filtro.dataDal;
                filtro.dataOraFine = filtro.dataAl;

                filtro.dataOraEsecuzioneDal = null;
                filtro.dataOraEsecuzioneAl = null;
            }

            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem("filtroRiepilogoVociMenu", JSON.stringify(me.filtroRiepilogoVociMenu));

            me.$refs.riepilogoVociDiarioList.loadData(filtro);
        },
        resetFiltroRiepilogoVociMenu() {
            let me = this;

            me.filtroRiepilogoVociMenu = {
                lastnameUpdater: "",
                firsnameUpdater: "",
                cognomePaziente: "",
                nomePaziente: "",
                useDataEsecuzione: true,
                dataDal: null,
                dataAl: null,
            };

            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem("filtroRiepilogoVociMenu", JSON.stringify(me.filtroRiepilogoVociMenu));

            me.$refs.riepilogoVociDiarioList.loadData(me.filtroRiepilogoVociMenu);
        },
        afterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        beforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
    },
};
</script>
<style scoped>
::v-deep .sa-date-like-input .mx-icon-calendar,
::v-deep .sa-date-like-input .mx-icon-clear {
    display: none !important;
}
</style>
